import { getField, updateField } from "vuex-map-fields";
import { getCard, getCards, getSelectorComments, createComment, editComment } from "../../feathers";
import { searchApplicantsCard, rateApplicant, rateApplicantEdit, getRatedApplicants, getUnratedApplicants, downloadApplicantZip } from "../../feathers";
import { generateExcel } from "../../feathers"
import { validPassport } from "../../feathers"


const state = {
    total: null,
    applicantsList: [],
    TotalApplicantsList: null,
    TotalRatedApplicantsList: null,
    TotalUnratedApplicantsList: null,
    ratedApplicants: null,
    unratedApplicants: null,
    commentGiven: null,
    commentsRetrieved: null,
    commentEdited: null,
    excelFile: null,
    PassportValid:null
}

const mutations = {
    updateField
};

const getters = {
    getField
}

const actions = {
    /**
      * Interfaces 
      * @param {} param0 
      * @param {String} groupConversationId 
      * @param {String} comment 
      * @param {String} messageType 
      */
    async getApplicantCards({ commit }, { limit, skip }) {

        const { data, total } = await getCards(limit, skip);
        // const {total } = await getCards();

        if (data && data.length > 0) {
            //update the store state
            commit("updateField", {
                path: "applicantsList",
                value: data
            });

            commit("updateField", {
                path: "TotalApplicantsList",
                value: total
            });
            return data;
        }
        else {
            return null;
        }

    },

    async getApplicantCard({ userId }) {
        const { data } = await getCard(userId);
        if (data && data.length > 0) {
            // console.log("IsLogged ifMod", data);
            return data;
        } else {
            // console.log("IsLogged elseMod", data);
            return null;
        }
    },

    async getRatedApplicantCards({ commit }, { limit, skip }) {
        const { data, total } = await getRatedApplicants(limit, skip);

        if (data && data.length > 0) {
            commit("updateField", {
                path: "ratedApplicants",
                value: data
            });

            commit("updateField", {
                path: "TotalRatedApplicantsList",
                value: total
            });
            // console.log("THEDATA", data);
            return data;
        } else {
            return null;
        }

    },

    async getUnratedApplicantCards({ commit }, { limit, skip }) {
        const { data, total } = await getUnratedApplicants(limit, skip);
        if (data && data.length > 0) {
            commit("updateField", {
                path: "unratedApplicants",
                value: data
            });
            commit("updateField", {
                path: "TotalUnratedApplicantsList",
                value: total
            });
            return data;
        } else {
            return null;
        }

    },

    async getComments({ commit }, { skip, groupConversationId }) {

        const comments = await getSelectorComments(skip, groupConversationId)
        
        if (comments.data.length > 0) { //comments.data

            commit("updateField", {
                path: "commentsRetrieved",
                value: comments.data
            });

            return comments.data;

        } else {
            return [];
        }

    },
    async createSelectorComment({ commit }, { groupConversationId, text, messageType }) {
        const commented = await createComment(groupConversationId, text, messageType);

        commit("updateField", {
            path: "commentGiven",
            value: commented
        });

        return commented;
    },
    async editSelectorComment({ commit }, { _id, text }) {


        const edited = await editComment(_id, text);

        commit("updateField", {
            path: "commentEdited",
            value: edited
        });

        return edited;

    },
    async searchApplicantsCard({ commit }, { word, onlyRated }) {
        // console.log("SEARCH selector mod", word, onlyRated);
        const { data } = await searchApplicantsCard(word, onlyRated);
        if (data && data.length > 0) {
            //update the store state
            commit("updateField", {
                path: "applicantsList",
                value: data
            })
            // console.log("SEARCH selector mod", data);
            return data;
        }
        else {
            return null;
        }
    },

    async rateApplicant(_, { academicRating, experienceRating, overallRating, applicantCardId }) {
        return await rateApplicant(academicRating, experienceRating, overallRating, applicantCardId);
    },
    async rateApplicantEdit(_, { ratingId, academicRating, experienceRating, overallRating, applicantCardId }) {
        return await rateApplicantEdit(ratingId, academicRating, experienceRating, overallRating, applicantCardId);
    },
    async getGeneratedExcelFile({ commit }) {

        // console.log("Im in the excel")
        const { url } = await generateExcel();
        commit("updateField", {
            path: "excelFile",
            value: url
        })
        return url
    },
    async validatePassport({_id, isPassportValid}){   
      return await validPassport(_id, isPassportValid);
    },

    async downloadApplicantZip(_, applicantId) {
        return await downloadApplicantZip(applicantId);
    }   
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};

